import { Suspense, useEffect } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { AppLayout } from '../layout/AppLayout'
import { PageLoader } from '../layout/PageLoader'
import { ProtectedRoute } from '../routing/ProtectedRoute'
import { AUTH_PATHS, PUBLIC_PATHS } from './routes'
import {
  About,
  AccountRecovery,
  EmbedCall,
  ForgotAccess,
  FrankyDashboard,
  LandingPage,
  Login,
  PhoneVerify,
  QrAuth,
  SharedCall,
  Waitlist,
} from './lazyPages'
import { PREVIEWS } from '../../previews/registry'

function PricingRedirect() {
  useEffect(() => {
    window.location.href = '/#pricing'
  }, [])
  return <PageLoader />
}

function AppGate() {
  const token = localStorage.getItem('reeva_auth_token')
  const location = useLocation()
  if (!token && location.pathname === '/') return <LandingPage />
  if (!token) {
    const redirect = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`${AUTH_PATHS.login}?redirect=${redirect}`} replace />
  }
  return <AppLayout />
}

function AppRedirect() {
  const location = useLocation()
  const newPath = (location.pathname.replace('/app', '') || '/') + location.search + location.hash
  return <Navigate to={newPath} replace />
}

function ReevaRedirect() {
  const location = useLocation()
  const newPath = (location.pathname.replace(/^\/reeva/, '') || '/') + location.search + location.hash
  return <Navigate to={newPath} replace />
}

function LovelineRedirect() {
  useEffect(() => {
    window.location.replace('https://loveline.returned.com/')
  }, [])
  return <PageLoader />
}

export function AppRouter() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
        <Route path={AUTH_PATHS.login} element={<Login />} />

        <Route path={PUBLIC_PATHS.pricing} element={<PricingRedirect />} />
        <Route path={PUBLIC_PATHS.about} element={<About />} />
        <Route path={PUBLIC_PATHS.waitlist} element={<Waitlist />} />
        <Route path={PUBLIC_PATHS.sharedCall} element={<SharedCall />} />
        <Route path={PUBLIC_PATHS.embedCall} element={<EmbedCall />} />

        <Route path={PUBLIC_PATHS.deprecatedClaim} element={<Navigate to="/" replace />} />

        <Route path={AUTH_PATHS.verify} element={<PhoneVerify />} />
        <Route path={AUTH_PATHS.recover} element={<AccountRecovery />} />
        <Route path={AUTH_PATHS.forgotAccess} element={<ForgotAccess />} />
        <Route path={AUTH_PATHS.qrAuth} element={<QrAuth />} />

        {Object.entries(PREVIEWS).map(([key, preview]) => {
          const Element = preview.element
          return <Route key={key} path={preview.path} element={<Element />} />
        })}

        <Route path="/franky/dashboard" element={<FrankyDashboard />} />

        <Route path="/love/admin" element={<LovelineRedirect />} />
        <Route path="/love-account" element={<LovelineRedirect />} />
        <Route path="/love-memory" element={<LovelineRedirect />} />
        <Route path="/love/account" element={<LovelineRedirect />} />
        <Route path="/love/memory" element={<LovelineRedirect />} />
        <Route path="/love" element={<LovelineRedirect />} />
        <Route path="/love/*" element={<LovelineRedirect />} />
        <Route path="/loveline" element={<LovelineRedirect />} />
        <Route path="/loveline/*" element={<LovelineRedirect />} />

        <Route path="/reeva/*" element={<ReevaRedirect />} />
        <Route path="/app/*" element={<AppRedirect />} />
        <Route path="/*" element={<AppGate />} />
      </Routes>
    </Suspense>
  )
}
